import React from 'react';
import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import { useBlobStorage } from 'hooks/blobStorage/useBlobStorage';
import { useWorkspaceContext } from 'hooks/common';
import { SparkDialog } from 'sharedComponents/UI';

type DocumentType = {
  uri: string;
  fileType: string;
  fileName: string;
};

type FileViewDialogProps = {
  fileURL: string;
  open: boolean;
  onClose: () => void;
};

function FileViewDialog({ fileURL, onClose, open }: FileViewDialogProps) {
  const [document, setDocument] = React.useState<DocumentType[] | null>();
  const fileURLSections = fileURL.split('/');
  const fileName = fileURLSections[fileURLSections.length - 1];
  const fileType = fileName.split('.')[1];

  const { getWorkspace } = useWorkspaceContext();
  const workSpace = getWorkspace();

  const { getBlockBlobClient } = useBlobStorage(
    workSpace?.attributes?.containerName || 'temp'
  );

  React.useEffect(() => {
    if (document?.length) {
      return;
    }
    getBlockBlobClient(fileName).then((data) => {
      setDocument([
        { fileType: fileType, uri: data?.url || '', fileName: fileName },
      ]);
    });
  }, [document?.length, fileName, fileType, fileURL, getBlockBlobClient]);

  return (
    <SparkDialog
      open={open}
      onClose={onClose}
      title={fileName}
      dialogContentStyles={{
        height: '100vh',
        '& #header-bar': {
          display: 'none',
        },
      }}
    >
      <DocViewer
        documents={document || []}
        pluginRenderers={DocViewerRenderers}
      />
    </SparkDialog>
  );
}

export default FileViewDialog;
